import { PayloadAction } from '@reduxjs/toolkit'
import { IRequestTemplate } from 'legacy/lut/classes/models/onboarding/RequestTemplate'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IForm } from 'core-components/classes/models/IForm'

import { mapRequestTemplateFromCrud } from '../../services/mapping/mapRequestTemplateFromCrud'
import {
  IOnboardingState,
  IRequestTemplateActionParams,
  IRequestTemplateByRequestIdActionParams,
} from '../models'

export const getRequestTemplatePending = (
  state: IOnboardingState,
  action: PayloadAction<
    unknown,
    string,
    { arg: IRequestTemplateActionParams | IRequestTemplateByRequestIdActionParams }
  >
) => {
  const { meta } = action

  state.requestTemplateData.meta = meta
  state.requestTemplateData.status = RequestStatus.PENDING
  state.requestTemplateData.message = ''
}

export const getRequestTemplateRejected = (
  state: IOnboardingState,
  action: PayloadAction<
    unknown,
    string,
    { arg: IRequestTemplateActionParams | IRequestTemplateByRequestIdActionParams }
  >
) => {
  const { meta } = action

  state.requestTemplateData.meta = meta
  state.requestTemplateData.status = RequestStatus.REJECTED
  state.requestTemplateData.message = action.payload as string
}

export const getRequestTemplateFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<IForm | null, string, { arg: IRequestTemplateActionParams }>
) => {
  const { meta, payload } = action

  state.requestTemplateData.meta = meta
  state.requestTemplateData.status = RequestStatus.FULFILLED
  state.requestTemplateData.message = ''
  if (payload && payload.template) {
    state.requestTemplateData.data = mapRequestTemplateFromCrud(payload.template)
  }
}

export const getRequestTemplateByRequestIdFulfilled = (
  state: IOnboardingState,
  action: PayloadAction<
    IRequestTemplate | null,
    string,
    { arg: IRequestTemplateByRequestIdActionParams }
  >
) => {
  const { meta, payload } = action

  state.requestTemplateData.meta = meta
  state.requestTemplateData.status = RequestStatus.FULFILLED
  state.requestTemplateData.message = ''
  if (payload) {
    state.requestTemplateData.data = payload
  }
}
